<template>
    <div 
    id="g-recaptcha"
    class="g-recaptcha"
    :data-sitekey="sitekey">
    </div>
</template>

<script>

export default {
  data() {
    return {
        sitekey: '6Lcz1i0pAAAAAFLCzz-HMNVyyXsuFwVHJIVf8bRV',
        widgetid: 0
    };
  },
  methods: {
    execute () {
      window.grecaptcha.execute(this.widgetid)
    },
    reset () {
      window.grecaptcha.reset(this.widgetid)
    },
    render () {
      if (window.grecaptcha) {
        this.widgetid = window.grecaptcha.render('g-recaptcha', {
          sitekey: this.sitekey,
          size: 'invisible',
          // the callback executed when the user solve the recaptcha
          callback: (response) => {
            // emit an event called verify with the response as payload
            this.$emit('verify', response)
            // reset the recaptcha widget so you can execute it again
            this.reset() 
          }
        })
      }
    }
  },
  mounted () {
    // render the recaptcha widget when the component is mounted
    this.render()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.grecaptcha-badge{
    transition:all 2s;
}
</style>
